import type { MenuProps } from 'antd';
import { Col, Menu, Row, Skeleton, theme } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoPersonCircleSharp } from 'react-icons/io5';
import { MdExitToApp } from 'react-icons/md';
import { TfiKey } from 'react-icons/tfi';
import { VscGlobe } from 'react-icons/vsc';
import { container } from 'tsyringe';

import { LanguageType, ThemeType } from '@/v1/main/domain/config';
// import { BiSun, BiMoon } from 'react-icons/bi';
import { AuthServiceImpl } from '@/v1/main/usecases';
import { ChangePasswordForm } from '@/v1/main/views/Form';
import { LogoHeaderImage, LogoImage } from '@/v1/main/views/Image';
import { Navbar } from '@/v1/main/views/Navbar';
import { useAuth, useLanguage } from '@/v1/main/views/Provider';

export const MenuHeader: React.FC = () => {
    const { t } = useTranslation(['interface', 'config']);
    const usecase = container.resolve(AuthServiceImpl);
    // const { theme, toggleTheme } = useTheme();
    // let themeLabel = theme == ThemeType.DARK ? ThemeType.LIGHT : ThemeType.DARK;
    // let ThemeIcon: IconImg = theme == ThemeType.DARK ? BiSun : BiMoon;

    const { language, changeLanguage } = useLanguage();

    const { nickname, setLoggedIn } = useAuth();
    const [changePassword, setChangePassword] = useState<boolean>(false);

    // useLayoutEffect(() => {
    //     themeLabel = theme == ThemeType.DARK ? ThemeType.LIGHT : ThemeType.DARK;
    //     ThemeIcon = theme == ThemeType.DARK ? BiSun : BiMoon;
    // }, [theme]);

    // const onToggleTheme = () => {
    //     toggleTheme();
    // };

    const onChangeLanguage: MenuProps['onClick'] = (e) => {
        changeLanguage(e.key as LanguageType);
    };

    const onLogout = () => {
        setLoggedIn(false);
    };

    const onChangePassword = () => {
        setChangePassword(true);
    };

    const onClose = () => {
        setChangePassword(false);
    };

    const languageItems: MenuProps['items'] = Object.values(LanguageType).map(
        (value: LanguageType) => {
            return {
                key: value,
                label: t(`language.${value}`, { ns: 'config' }),
                onClick: onChangeLanguage,
            };
        }
    );

    const items: MenuProps['items'] = [
        // {
        //     key: 'theme',
        //     label: t(`theme.${themeLabel}`, { ns: 'config' }),
        //     icon: <ThemeIcon />,
        //     onClick: onToggleTheme,
        // },
        {
            key: 'language',
            label: t(`language.${language}`, { ns: 'config' }),
            icon: <VscGlobe />,
            children: languageItems,
        },
    ];
    if (nickname) {
        items.push({
            key: 'user',
            label: nickname,
            icon: <IoPersonCircleSharp />,
            children: [
                {
                    key: 'change_password',
                    label: t('action.change_password', { ns: 'interface' }),
                    icon: <TfiKey />,
                    onClick: onChangePassword,
                },
                {
                    key: 'logout',
                    label: t('action.logout', { ns: 'interface' }),
                    icon: <MdExitToApp />,
                    onClick: onLogout,
                },
            ],
        });
    }
    const auth = useAuth();
    const {
        token: { colorPrimary },
    } = theme.useToken();
    return (
        <Skeleton loading={items.length == 0} style={{ padding: 12 }}>
            <Row align="middle" justify="space-between">
                <Col xl={4} lg={4} md={4} sm={4} xs={4}>
                    {auth.loggedIn && <LogoImage themeType={ThemeType.DARK} />}
                </Col>
                <Col xl={16} lg={16} md={16} sm={16} xs={16}>
                    {auth.loggedIn && <Navbar />}
                </Col>
                <Col xl={4} lg={4} md={4} sm={4} xs={4}>
                    <Menu
                        mode="horizontal"
                        items={items}
                        style={{
                            justifyContent: 'end',
                            background: colorPrimary,
                        }}
                    />
                </Col>
            </Row>
            <ChangePasswordForm
                open={changePassword}
                onClose={onClose}
                usecase={usecase}
            />
        </Skeleton>
    );
};
